import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { StructureComponent } from './structure/structure.component';

import { AppRoutingModule, routing, appRoutingProviders } from './app.routing';
import { StyleComponent } from './style/style.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { UiElementsComponent } from './ui-elements/ui-elements.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSliderModule } from '@angular/material/slider';
//import { ToastModule } from 'ng2-toastr/ng2-toastr';
import { ToastrModule } from 'ngx-toastr';
import { PersonasComponent } from './personas/personas.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SlimLoadingBarModule } from 'ng2-slim-loading-bar';
import { NgSelectModule } from '@ng-select/ng-select';
import { GuidelinesComponent } from './guidelines/guidelines.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ExemplifyModule } from '../exemplify/exemplify.module';
import { TextMaskModule } from 'angular2-text-mask';
import { PrototypeComponent } from './prototype/prototype.component';
import { QuillModule } from 'ngx-quill';
import { jqxDateTimeInputComponent } from 'jqwidgets-framework/jqwidgets-ts/angular_jqxdatetimeinput';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';


@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    StructureComponent,
    StyleComponent,
    WelcomeComponent,
    UiElementsComponent,
    PersonasComponent,
    GuidelinesComponent,
    PrototypeComponent,
    jqxDateTimeInputComponent
  ],
  imports: [
    BrowserModule,
    routing,
    MatExpansionModule,
    BrowserAnimationsModule,
    MatTabsModule,
    MatTooltipModule,
    MatSliderModule,
    ToastrModule.forRoot(),
    MatSlideToggleModule,
    SlimLoadingBarModule.forRoot(),
    NgSelectModule,
    ReactiveFormsModule,
    ExemplifyModule,
    TextMaskModule,
    QuillModule,
    FormsModule,
    DataTablesModule
  ],
  providers: [appRoutingProviders],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/src/app/app.module.ts